import apiClient from './client';

// GET /api/dashboard/summary
// Query params: from, to, owner_id, region (all optional)
export async function fetchDashboardSummary(params = {}) {
  const response = await apiClient.get('/dashboard/summary', { params });
  return response.data;
}
